module.exports = __webpack_public_path__ + "img/logo.848f47af.png";